import Dictionary from "./Dictionary";
function App() {
  return (
    <div className="App">
      <Dictionary defaultKeyword="hello"/>
    </div>
  );
}

export default App;
